<template>
  <div
    v-if="elements"
    class="radio-button-group"
  >
    <input
      type="radio"
      class="radio-button-group-item"
      :class="{
        stars: element.value === maximumValue && presentationMode,
        'checked-btn': checked === index,
      }"
      name="definedTips"
      v-for="(element, index) in elements"
      :key="index"
      v-model="vModel"
      :label="
        element.value.toLocaleString($localeString, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      "
      :value="tipsFormatter(element.value)"
      @change="change(tipsFormatter(element.value), index)"
      :style="{
        '--active-bg': profileColor,
        '--active-shadow': `0 0 4px ${profileColor}40, 0 0 8px ${profileColor}69`,
      }"
    >
  </div>
</template>

<script>

export default {
  name: "DefinedTipsAmount",
  props: {
    elements: {
      type: Array,
      default: () => {
        return [];
      },
    },
    employee: {
      type: Object,
      default: () => {},
    },
    presentationMode: {
      type: Boolean,
      default: false
    },
    model: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: "EUR",
    },
    primaryColor: {
      type: String,
      default: "#FF8A00",
    },
  },
  data() {
    return {
      checked: null,
    };
  },
  computed: {
    maximumValue() {
      return Math.max(...this.pluck(this.elements, "value"));
    },
    profileColor() {
      return this.primaryColor == null ? "#FF8A00" : this.primaryColor;
    },
    vModel: {
      get: function() {
        return this.model;
      },
      set: function(value) {
        this.$emit("update:model", value);
      },
    },
  },
  created() {
    this.elements.map((element, key) => {
      if (element.checked) {
        this.$emit(
          "change",
          this.tipsFormatter(element.value),
          this.employee?.qrCode || null
        );
        this.vModel = this.tipsFormatter(element.value);
        this.checked = key;
      }
    });
  },
  methods: {
    tipsFormatter(value) {
      return Number((value * 100).toFixed(0))
    },
    pluck (array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },
    change(value, index) {
      this.$amplitude.logEvent("Payment page event Tips change", {
        qrCode: this.$route.params.qrCode,
        amount: value,
      });

      this.$axios.post("/api/v1/fe-status", {
        status: 200,
        message: "Payment page event Tips change",
        qrCode: this.$route.params.qrCode,
        timestamp: Date.now(),
        data: value,
      });

      this.$emit("change", value, this.employee?.qrCode || null);
      this.checked = index;
    },
  },
  watch: {
    model(value) {
      const foundIndex = this.elements.findIndex((el) => {
        const formatter = new Intl.NumberFormat(this.$localeString);
        return formatter.format(el.value * 100) === formatter.format(value);
      });

      foundIndex !== -1 ? (this.checked = foundIndex) : (this.checked = null);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-button-group {
  height: 45px;
  background: #f6f7f9;
  border-radius: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .checked-btn {
    background-color: var(--active-bg);
    color: #ffffff;
    box-shadow: var(--active-shadow);
    border-radius: 24px;
  }

  &-item {
    width: 100%;
    height: 100%;
    margin: 0;
    appearance: none;
    outline: none;
    cursor: pointer;
    color: #2d2e2f;
    font-size: 14px;
    font-family: "Raleway Bold", serif;
    font-feature-settings: "pnum" on, "lnum" on;

    &.stars:after {
      background-image: url(https://tippiie-images.s3.eu-central-1.amazonaws.com/stars.gif);
      background-size: 100px 100px;
      background-repeat: no-repeat;
      display: block;
      position: absolute;
      width: 100px;
      height: 100px;
      right: 20px;
      bottom: 0px;
      content: "";
    }

    &:before {
      content: attr(label);
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }
}
</style>
